<template>
  <i :class="[icon, 'fa-solid transform transition-transform duration-200', disabled ? 'cursor-not-allowed' : 'cursor-pointer']" />
</template>

<script setup>
const props = defineProps({
  icon: String,
  disabled: { type: Boolean, default: false },
})
</script>
